import { render, staticRenderFns } from "./AbHistogram.vue?vue&type=template&id=246fdefa&scoped=true"
import script from "./AbHistogram.vue?vue&type=script&lang=js"
export * from "./AbHistogram.vue?vue&type=script&lang=js"
import style0 from "./AbHistogram.vue?vue&type=style&index=0&id=246fdefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246fdefa",
  null
  
)

export default component.exports